/* obuolys-reels — savas shoppable video grotuvas (Reel Up pakaitalas) */
(() => {
  if (window.__obuReels) return;
  window.__obuReels = true;

  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection && navigator.connection.saveData;
  const previewsOk = !reduce && !saveData;

  document.querySelectorAll('[data-obu-reels]').forEach(init);

  function init(root) {
    const tpl = root.querySelector('[data-obu-reels-data]');
    /* Langelį dedam į tą vietą, kurią nurodo jo paties numeris — ne pagal eilę
       masyve. Jei kuris nors langelis neatsirastų, kortelės vis tiek atidarys
       teisingą video, o ne pasislinkusį. */
    const slides = [];
    if (tpl) {
      tpl.content.querySelectorAll('[data-obu-reel-slide]').forEach((d) => {
        slides[Number(d.dataset.obuReelSlide)] = d;
      });
    }

    /* --- juostos peržiūros: groja tik matomos, daugiausiai 2 vienu metu --- */
    if (previewsOk && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          const v = e.target;
          if (e.isIntersecting) {
            if (root.querySelectorAll('.is-playing').length >= 2) return;
            if (!v.src) {
              v.src = v.dataset.src;
              /* lengvos versijos gali ir nebūti — tada imam pilną failą */
              v.addEventListener('error', () => {
                const full = v.dataset.srcFull;
                if (full && !v.src.endsWith(full)) { v.src = full; v.play().catch(() => {}); }
              }, { once: true });
            }
            v.play().then(() => v.classList.add('is-playing')).catch(() => {});
          } else {
            v.pause();
            v.classList.remove('is-playing');
          }
        });
      }, { threshold: 0.6 });
      root.querySelectorAll('[data-obu-reel-preview]').forEach((v) => io.observe(v));
    }

    let ov = null, current = 0, muted = true;

    root.querySelectorAll('[data-obu-reel-open]').forEach((btn) => {
      btn.addEventListener('click', () => open(Number(btn.dataset.obuReelOpen)));
    });

    function build() {
      ov = document.createElement('div');
      ov.className = 'obu-reels-ov';
      ov.setAttribute('role', 'dialog');
      ov.setAttribute('aria-modal', 'true');
      ov.innerHTML =
        '<div class="obu-reels-ov__stage">' +
          '<div class="obu-reels-ov__bars" data-bars></div>' +
          '<video class="obu-reels-ov__video" playsinline autoplay muted></video>' +

          '<div class="obu-reels-ov__top">' +
            '<button class="obu-reels-ov__btn" data-mute aria-label="Įjungti garsą">' + icon('mute') + '</button>' +
            '<button class="obu-reels-ov__btn" data-close aria-label="Uždaryti">' + icon('x') + '</button>' +
          '</div>' +

          '<div class="obu-reels-ov__nav">' +
            '<button class="obu-reels-ov__navbtn" data-prev aria-label="Ankstesnis vaizdo įrašas">' + icon('up') + '</button>' +
            '<button class="obu-reels-ov__navbtn" data-next aria-label="Kitas vaizdo įrašas">' + icon('down') + '</button>' +
          '</div>' +

          '<div class="obu-reels-ov__rail">' +
            '<button class="obu-reels-ov__action" data-share aria-label="Dalintis" title="Dalintis">' +
              icon('share') + '</button>' +
            /* tie patys požymiai kaip antraštės mygtuko — tema atidaro krepšelio langą,
               kuriame matoma klubo kaina (/cart puslapyje jos nėra) */
            '<a class="obu-reels-ov__action cart-drawer-button" href="/cart"' +
              ' aria-controls="CartDrawer" aria-label="Krepšelis" title="Krepšelis">' +
              '<span class="obu-reels-ov__bag">' + icon('bag') +
              '<span class="obu-reels-ov__count" data-count hidden></span></span></a>' +
          '</div>' +

          '<div data-slot></div>' +
        '</div>';
      document.body.appendChild(ov);

      const v = ov.querySelector('video');
      v.addEventListener('timeupdate', tick);
      v.addEventListener('ended', () => go(1));
      v.addEventListener('click', () => (v.paused ? v.play() : v.pause()));

      ov.querySelector('[data-close]').addEventListener('click', close);
      ov.querySelector('[data-prev]').addEventListener('click', () => go(-1));
      ov.querySelector('[data-next]').addEventListener('click', () => go(1));
      ov.querySelector('[data-mute]').addEventListener('click', (e) => {
        muted = !muted;
        v.muted = muted;
        const b = e.currentTarget;
        b.innerHTML = icon(muted ? 'mute' : 'sound');
        b.setAttribute('aria-label', muted ? 'Įjungti garsą' : 'Išjungti garsą');
      });
      ov.querySelector('[data-share]').addEventListener('click', share);

      /* juostelės viršuje — po vieną kiekvienam video (kaip Instagram) */
      const bars = ov.querySelector('[data-bars]');
      bars.innerHTML = slides.map(() => '<span><i></i></span>').join('');

      let y0 = null;
      ov.addEventListener('touchstart', (e) => { y0 = e.touches[0].clientY; }, { passive: true });
      ov.addEventListener('touchend', (e) => {
        if (y0 === null) return;
        const dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dy) > 60) go(dy < 0 ? 1 : -1);
        y0 = null;
      }, { passive: true });

      ov.addEventListener('click', (e) => {
        const add = e.target.closest('[data-obu-reel-add]');
        if (add) { addToCart(add); return; }
        /* Krepšelis — atidarom temos krepšelio langą (jame matoma klubo kaina;
           /cart puslapyje eilutės rodomos pilna kaina). Temos valdiklis mūsų
           nuorodos neperima, nes ji sukuriama jau po puslapio įkrovimo, todėl
           kviečiam jo API patys. Nepavykus — paprasta /cart nuoroda. */
        if (e.target.closest('a[href="/cart"]')) {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.show === 'function') {
            e.preventDefault();
            close();
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            drawer.show();
          } else {
            close();
          }
        }
      });
      document.addEventListener('keydown', onKey);
      refreshCount();
    }

    function tick() {
      const v = ov.querySelector('video');
      const bars = ov.querySelectorAll('[data-bars] i');
      if (!bars[current]) return;
      bars[current].style.width = v.duration ? (v.currentTime / v.duration) * 100 + '%' : '0';
    }

    function onKey(e) {
      if (!ov || ov.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') go(1);
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') go(-1);
    }

    function open(i) {
      if (!ov) build();
      ov.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      show(i);
    }

    function close() {
      ov.hidden = true;
      ov.querySelector('video').pause();
      document.documentElement.style.overflow = '';
    }

    function go(step) {
      let next = current + step;
      while (next >= 0 && next < slides.length && !slides[next]) next += step;
      if (next < 0 || next >= slides.length) { if (step > 0) close(); return; }
      show(next);
    }

    function show(i) {
      if (!slides[i]) return;
      const bars = ov.querySelectorAll('[data-bars] i');
      bars.forEach((b, n) => { b.style.width = n < i ? '100%' : '0'; });
      current = i;
      const data = slides[i];
      const v = ov.querySelector('video');
      v.poster = data.dataset.poster || '';
      v.src = data.dataset.src;
      v.muted = muted;
      v.play().catch(() => {});
      const slot = ov.querySelector('[data-slot]');
      slot.innerHTML = '';
      const tagged = data.querySelector('.obu-reels__tagged');
      if (tagged) slot.appendChild(tagged.cloneNode(true));
      const nxt = slides[i + 1];
      if (nxt && nxt.dataset.poster) { const p = new Image(); p.src = nxt.dataset.poster; }
      ov.querySelectorAll('[data-prev],[data-next]').forEach((b) => {
        b.disabled = b.hasAttribute('data-prev') ? i === 0 : i === slides.length - 1;
      });
    }

    async function share(e) {
      const btn = e.currentTarget;
      const link = slides[current].querySelector('.obu-reels__prod-link');
      const url = link ? link.href : location.href;
      const title = document.title;
      if (navigator.share) {
        try { await navigator.share({ title, url }); } catch (_) {}
        return;
      }
      try {
        await navigator.clipboard.writeText(url);
        const lbl = btn.querySelector('span');
        lbl.textContent = 'Nukopijuota';
        setTimeout(() => { lbl.textContent = 'Dalintis'; }, 1600);
      } catch (_) {}
    }

    async function refreshCount() {
      try {
        const c = await (await fetch('/cart.js')).json();
        const el = ov.querySelector('[data-count]');
        el.textContent = c.item_count;
        el.hidden = c.item_count === 0;
      } catch (_) {}
    }

    async function addToCart(btn) {
      const id = btn.dataset.obuReelAdd;
      const label = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
        });
        if (!r.ok) throw new Error();
        btn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
        btn.setAttribute('aria-label', 'Įdėta į krepšelį');
        btn.classList.add('is-done');
        refreshCount();
        /* prekė krepšelyje — kortelė pasitraukia, kaip ir lipni PDP juosta */
        const card = btn.closest('.obu-reels__prod');
        if (card) {
          setTimeout(() => {
            card.classList.add('is-gone');
            setTimeout(() => {
              const wrap = card.parentElement;
              card.remove();
              if (wrap && !wrap.querySelector('.obu-reels__prod')) wrap.remove();
            }, 400);
          }, 900);
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      } catch (_) {
        btn.textContent = label;
        btn.disabled = false;
      }
    }
  }

  function icon(n) {
    const s = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
    if (n === 'x')     return s + '<path d="M6 6l12 12M18 6L6 18"/></svg>';
    if (n === 'up')    return s + '<path d="M18 15l-6-6-6 6"/></svg>';
    if (n === 'down')  return s + '<path d="M6 9l6 6 6-6"/></svg>';
    if (n === 'share') return s + '<path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7Z"/></svg>';
    if (n === 'bag') {
      /* ta pati ikona kaip puslapio antraštėje (Hyper icon-shopping-bag) */
      return '<svg viewBox="0 0 20 20" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M16.3804 16.25H3.61947C3.46585 16.25 3.31752 16.1939 3.20241 16.0922C3.0873 15.9904 3.01334 15.8501 2.99447 15.6977L1.88119 6.32267C1.87089 6.2347 1.87941 6.14556 1.90617 6.06113C1.93294 5.9767 1.97734 5.89893 2.03644 5.83296C2.09553 5.767 2.16797 5.71434 2.24896 5.67849C2.32995 5.64264 2.41763 5.62441 2.50619 5.62501H17.4937C17.5823 5.62441 17.6699 5.64264 17.7509 5.67849C17.8319 5.71434 17.9044 5.767 17.9634 5.83296C18.0225 5.89893 18.0669 5.9767 18.0937 6.06113C18.1205 6.14556 18.129 6.2347 18.1187 6.32267L17.0054 15.6977C16.9865 15.8501 16.9126 15.9904 16.7975 16.0922C16.6824 16.1939 16.534 16.25 16.3804 16.25Z"/>' +
        '<path d="M6.875 5.625V5C6.875 4.1712 7.20424 3.37634 7.79029 2.79029C8.37634 2.20424 9.1712 1.875 10 1.875C10.8288 1.875 11.6237 2.20424 12.2097 2.79029C12.7958 3.37634 13.125 4.1712 13.125 5V5.625"/></svg>';
    }
    if (n === 'mute')  return s + '<path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="M23 9l-6 6M17 9l6 6"/></svg>';
    return s + '<path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg>';
  }
})();
